<template>
  <v-app>
    <v-navigation-drawer
        fixed
        :clipped="$vuetify.breakpoint.mdAndUp"
        app
        v-model="drawer"
    >
      <v-list dense>
        <template v-for="item in adminItems">
          <v-list-tile v-if="!item.children" :to="item.to" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-group
              v-else
              v-model="item.model"
              :key="'group-' + item.text"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                :to="child.to"
                v-for="(child, i) in item.children"
                :key="i"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ child.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    
    <v-progress-linear
        v-if="this.$store.state.progress"
        color="deep-purple"
        indeterminate
        height="6"
        style="position: fixed; top: 50px; z-index: 99999"
    ></v-progress-linear>
    
    <v-toolbar
        color="red darken-2"
        app
        :clipped-left="$vuetify.breakpoint.mdAndUp"
        fixed
        dark
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <v-toolbar-side-icon
            @click.stop="drawer = !drawer"
        ></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">Admin Panel - {{ currentUser.firstName }}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
      <v-btn icon large @click="logout">
        <v-avatar size="32px" tile>
          <img src="@/assets/logo.svg" alt="Admin" />
        </v-avatar>
      </v-btn>
    </v-toolbar>

    <v-content>
      <router-view />
    </v-content>
    
    <v-dialog v-model="$store.state.dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Bilgilendirme</v-card-title>
        <v-card-text>{{ $store.state.message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="success"
              dark
              depressed
              @click="$store.state.dialog = false"
          >Tamam</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { authenticationService } from "@/_services";

export default {
  data() {
    return {
      currentUser: null,
      drawer: null,
      fullAdminItems: [
        { icon: "dashboard", text: "Dashboard", to: "/admin" },
        { icon: "people", text: "Kullanıcılar", to: "/admin/users" },
        { icon: "business", text: "Kullanıcı Tenants", to: "/admin/user-tenants" },
        { icon: "account_balance", text: "Anlaşmalı Bankalar", to: "/admin/partner-banks" },
        {
          icon: "assessment",
          text: "Kampanya Komisyonları",
          to: "/admin/campaign-commissions"
        },
        { icon: "settings", text: "Uygulama Ayarları", to: "/admin/app-settings" }, 
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "Ürün Yönetimi",
          model: false,
          children: [
            { icon: "list", text: "Ürün Listele", to: "/admin/product" },
            { icon: "add", text: "Ürün Ekle", to: "/admin/product/detail" }
          ]
        },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "İndirim Yönetimi",
          model: false,
          children: [
            { icon: "list", text: "İndirim Listele", to: "/admin/discount" },
            { icon: "add", text: "İndirim Ekle", to: "/admin/discount/detail" }
          ]
        },
        {
          icon: "assessment",
          text: "Kampanya Komisyonları",
          to: "/admin/campaign-commissions"
        },
        {
          icon: "payment",
          text: "Beklenen Ödeme Kalemleri",
          to: "/admin/expected-payments"
        },
        {icon: "keyboard_arrow_up","icon-alt": "keyboard_arrow_down", model: false, text: "Idia Web",
        children: [
          { icon: "inventory_2", text: "Ürün Listele", to: "/admin/product" },
          { icon: "category", text: "Kategori Yönetimi", to: "/admin/categories" },
          { icon: "view_carousel", text: "Carousel Yönetimi", to: "/admin/carousels" },
          { icon: "star", text: "Çok Satanlar", to: "/admin/bestsellers" },
          { icon: "account_tree", text: "Varyant Yönetimi", to: "/admin/variants" }
            ]},
        
      ],
      adminWebItems: [
        {icon: "keyboard_arrow_up","icon-alt": "keyboard_arrow_down", model: true, text: "Idia Web",
        children: [
          { icon: "inventory_2", text: "Ürün Listele", to: "/admin/product" },
          { icon: "category", text: "Kategori Yönetimi", to: "/admin/categories" },
          { icon: "view_carousel", text: "Carousel Yönetimi", to: "/admin/carousels" },
          { icon: "star", text: "Çok Satanlar", to: "/admin/bestsellers" },
          { icon: "account_tree", text: "Varyant Yönetimi", to: "/admin/variants" }
            ]},
      ]
    };
  },
  computed: {
    adminItems() {
      if (this.currentUser && this.currentUser.isAdminWeb) {
        return this.adminWebItems;
      }
      return this.fullAdminItems;
    }
  },
  created() {
    authenticationService.currentUser.subscribe(
        (x) => {
          this.currentUser = x || {};
        }
    );
  },
  methods: {
    logout() {
      authenticationService.logout();
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
/* Admin paneli için özel stiller */
.v-toolbar {
  background: linear-gradient(45deg, #c62828, #d32f2f) !important;
}
</style>
